// HomeworkContext.js
import React, { createContext, useContext, useState } from 'react';

// Create Context
const HomeworkContext = createContext();

// Create a Provider Component
export const HomeworkProvider = ({ children }) => {
    const [openEditHw, setOpenEditHw] = useState(false); // dialog global for app bar
    const [selectedHw, setSelectedHw] = useState(null); // dialog global
    const [rating, setRating] = useState(0); // dialog global
    const [group, setGroup] = useState("students"); // admin global

  return (
    <HomeworkContext.Provider
      value={{
        openEditHw,
        setOpenEditHw,
        selectedHw, 
        setSelectedHw,
        rating, 
        setRating,
        group,
        setGroup,
      }}
    >
      {children}
    </HomeworkContext.Provider>
  );
};

// Create a hook to use the Homework Context
export const useHomeworkContext = () => {
  return useContext(HomeworkContext);
};
